import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { IPatientInvoiceServicePrice } from '@common/interfaces/patientInvoiceServicePrice';
import { Currency } from '@frontend/components/elements/common';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { translateKey } from '@frontend/translate';

interface IPatientInvoiceServicePricesListProps {
    onClickEdit: (id: string) => void;
    onRemove: (id: string) => void;
    patientInvoiceServicePrices: IPatientInvoiceServicePrice[];
}

export function PatientInvoiceServicePricesList(props: IPatientInvoiceServicePricesListProps) {
    return (
        <TableContainer sx={{ width: '50%' }}>
            <Table spacing="medium">
                <TableHead>
                    <TableRow>
                        <TableHeader>{translateKey('common.startDate')}</TableHeader>
                        <TableHeader>{translateKey('common.endDate')}</TableHeader>
                        <TableHeader>{translateKey('common.price')}</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.patientInvoiceServicePrices.map((price) => (
                        <TableRow key={price.id}>
                            <TableCell>
                                <NullableFormattedDate value={price.startDate} />
                            </TableCell>
                            <TableCell>
                                <NullableFormattedDate value={price.endDate} />
                            </TableCell>
                            <TableCell>
                                <Currency value={price.price} />
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    icon="edit"
                                    labelText={translateKey('common.edit')}
                                    onClick={() => props.onClickEdit(price.id)}
                                    size="small"
                                />{' '}
                                <IconButton
                                    icon="delete"
                                    labelText={translateKey('common.remove')}
                                    onClick={() => props.onRemove(price.id)}
                                    size="small"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
